import { useEffect, useState } from "react";

const KEY = "showStockBatchAndExpiryInBillPrint";
const EVENT_NAME = "showStockBatchAndExpiryInBillPrintChanged";

// eslint-disable-next-line import/prefer-default-export
export const useShowStockBatchAndExpiryInBillPrint = (): {
  showStockBatchAndExpiryInBillPrint: boolean;
  setShowStockBatchAndkExpiryInBillPrint: (value: boolean) => void;
} => {
  const [showStockBatchAndExpiryInBillPrint, setShowStockBatchAndkExpiryInBillPrint] =
    useState<boolean>(() => {
      const stored = localStorage.getItem(KEY);
      return stored === null ? true : stored === "true";
    });

  // use effects
  useEffect(() => {
    localStorage.setItem(KEY, String(showStockBatchAndExpiryInBillPrint));
    window.dispatchEvent(new Event(EVENT_NAME));
  }, [showStockBatchAndExpiryInBillPrint]);

  useEffect(() => {
    const sync = () => {
      setShowStockBatchAndkExpiryInBillPrint(localStorage.getItem(KEY) === "true");
    };

    const handleStorage = (e: StorageEvent) => {
      if (e.key === KEY) {
        sync();
      }
    };

    window.addEventListener(EVENT_NAME, sync);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener(EVENT_NAME, sync);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return { showStockBatchAndExpiryInBillPrint, setShowStockBatchAndkExpiryInBillPrint };
};
